itsoftApp.createModule("animateScroll", ["windowResize"], function() {
    var maxMobileWidth = 767;
    var module = this;
    var loaded = false;
    var pageHeader = document.querySelector("[data-fixed='true']"); /* есть ли фиксированная шапка */
    var viewportSize = itsoftApp.utils.getViewportSize(); /* определяем текущий вьюпорт */
    var scroll;

    var getViewportSize = function () {
      viewportSize = itsoftApp.utils.getViewportSize();
    }

    var startScroll = function (target, padding, speed, speedAsDuration) {
      var defaultPadding = 0;

      /* вычисляет отступ сверху */
      if (pageHeader) {
        if (!itsoftApp.commonVars.headerHeight) {
          itsoftApp.utils.getHeaderHeight(); /* берём высоту шапки */
        }

        if (target.hasAttribute("data-offset")) {
          if (viewportSize <= maxMobileWidth) {
            defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
          } else {
            defaultPadding = itsoftApp.commonVars.headerHeight + itsoftApp.commonVars.headerHeight / 2;
          }
        } else if (target.hasAttribute("data-offset-mobile") && viewportSize <= maxMobileWidth) {
          defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
        } else {
          defaultPadding = itsoftApp.commonVars.headerHeight;
        }
      }

      /* добавляем отступ сверху, если, например, есть фиксированная шапка */
      var settings = {
        offset: defaultPadding
      }

      /* вычисляем скорость и время, за которое произойдёт прокрутка */

      if (speed) {
        settings.speed = speed;
      }

      if (speedAsDuration) {
        settings.speedAsDuration = speedAsDuration;
      }

      /* Уничтожаем предыдущий экземпляр, если он есть */
      if (scroll) {
        scroll.destroy();
        scroll = "";
      }
      
      scroll = new SmoothScroll();

      if (!document.body.classList.contains("is-popup-opened")) {
        scroll.animateScroll(target, "auto", settings);
      } else {
        setTimeout(function () {
          scroll.animateScroll(target, "auto", settings);
        }, 800)
      }
    }

    var load = function (target, padding, speed, speedAsDuration) {
      /* если библиотека для плавной анимации пока не загружена, загружаем... */
      if (!loaded) {
        itsoftApp.loadScript("/assets/scripts/smoothScroll/smooth-scroll.min.js", function () {
          loaded = true;
          startScroll(target, padding, speed, speedAsDuration);
        });
      } else {
        // иначе сразу запускаем функцию
        startScroll(target, padding, speed, speedAsDuration);
      }
    }

    var initAnimateScroll = function (el, padding) {
      el.addEventListener("click", function (evt) {
        evt.preventDefault();
        var scrollId = evt.currentTarget.href;
      
        if (!scrollId || !(scrollId = scrollId.split('#')[1])) {
          return;
        }

        /* Находим элемент, до которого нуңно прокрутить страницу, и передаём его в функцию */
        var target = document.querySelector('#' + scrollId);
        load(target);
      });
    }

    var links = document.querySelectorAll("a[href^='#']:not([href='#'])");

    /* Проходимся по всем элементам, у которых в href есть хэш */
    Array.prototype.forEach.call(links, function (el) {
      initAnimateScroll(el);
    });

    module.callback = load;

    itsoftApp.modules.windowResize.addEvent(getViewportSize);
});